import { take, call, put} from 'redux-saga/effects';
import {
    getKeiyakuKigyouListWD,
    failGetKeiyakuKigyouListWD,
    successGetKeiyakuKigyouListWD,
    getKeiyakuKigyou,
    failGetKeiyakuKigyou,
    successGetKeiyakuKigyou,
    delKeiyakuKigyou,
    failDelKeiyakuKigyou,
    successDelKeiyakuKigyou,
    restoreKeiyakuKigyou,
    failRestoreKeiyakuKigyou,
    successRestoreKeiyakuKigyou,
    setKeiyakuKigyou,
    failSetKeiyakuKigyou,
    successSetKeiyakuKigyou


} from '../../actions';
import superFetch from '../../modules/superFetch';
import {getApiUrl} from "./../index";


export function* handleGetKeiyakuKigyouListWD() {
    while (true) {
        yield take(`${getKeiyakuKigyouListWD}`);
        const { payload, err } = yield call(superFetch, {
            url: getApiUrl() + 'master/get-keiyakukigyou-list/',
            type: 'POST',
            data: {include_delete:true}
        });
        if (err || payload.state === 'NG') {
            const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
            yield put(failGetKeiyakuKigyouListWD({err:msg}));
            continue;
        }
        yield put(successGetKeiyakuKigyouListWD(Object.assign({}, payload, {})));
    }
}


export function* handleGetKeiyakuKigyou() {
    while (true) {
        const action = yield take(`${getKeiyakuKigyou}`);
        const { payload, err } = yield call(superFetch, {
            url: getApiUrl() + 'master/get-keiyakukigyou/',
            type: 'POST',
            data: action.payload
        });
        if (err || payload.state === 'NG') {
            const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
            yield put(failGetKeiyakuKigyou({err:msg}));
            continue;
        }
        yield put(successGetKeiyakuKigyou(Object.assign({}, payload, {})));
    }
}

export function* handleSetKeiyakuKigyou() {
    while (true) {
        const action = yield take(`${setKeiyakuKigyou}`);
        const { payload, err } = yield call(superFetch, {
            url: getApiUrl() + 'master/set-keiyakukigyou/',
            type: 'POST',
            data: action.payload
        });
        if (err || payload.state === 'NG') {
            const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
            yield put(failSetKeiyakuKigyou({err:msg}));
            continue;
        }
        yield put(successSetKeiyakuKigyou(Object.assign({}, payload, {})));
    }
}

export function* handleDelKeiyakuKigyou() {
    while (true) {
        const action = yield take(`${delKeiyakuKigyou}`);
        const { payload, err } = yield call(superFetch, {
            url: getApiUrl() + 'master/del-keiyakukigyou/',
            type: 'POST',
            data: action.payload
        });
        if (err || payload.state === 'NG') {
            const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
            yield put(failDelKeiyakuKigyou({err:msg}));
            continue;
        }
        yield put(successDelKeiyakuKigyou(Object.assign({}, payload, {})));
    }
}

export function* handleRestoreKeiyakuKigyou() {
    while (true) {
        const action = yield take(`${restoreKeiyakuKigyou}`);
        const { payload, err } = yield call(superFetch, {
            url: getApiUrl() + 'master/restore-keiyakukigyou/',
            type: 'POST',
            data: action.payload
        });
        if (err || payload.state === 'NG') {
            const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
            yield put(failRestoreKeiyakuKigyou({err:msg}));
            continue;
        }
        yield put(successRestoreKeiyakuKigyou(Object.assign({}, payload, {})));
    }
}







// WEBPACK FOOTER //
// ./src/sagas/master/keiyaku-kigyou.js